import React from 'react';
import SvgIcon from './SvgIcon';

const CurrentStatus = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M5.25 13.515h1.722a.187.187 0 00.147-.07l1.289-1.613a.188.188 0 01.3.009l1.562 2.187a.189.189 0 00.25.051.187.187 0 00.064-.066l2.288-3.922a.188.188 0 01.335.024l2.325 5.643a.188.188 0 00.341.012l1.264-2.526a.187.187 0 01.168-.104h1.445"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.5 4.5H5.25V21h13.5V4.5H16.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.809 2.625h4.441a.75.75 0 01.75.75V22.5a.75.75 0 01-.75.75H3.75A.75.75 0 013 22.5V3.375a.75.75 0 01.75-.75h4.428"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.625 2.25h-.787a1.875 1.875 0 00-3.675 0h-.788A1.772 1.772 0 007.5 4.125V5.25h9V4.125a1.791 1.791 0 00-1.875-1.875v0z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx={12} cy={3} r={1} fill="currentColor" />
    </SvgIcon>
);

CurrentStatus.displayName = 'CurrentStatusIcon';

export default CurrentStatus;
